import { FigureVarDataDto, isFigureVarDataDto } from "./FigureVarDataDto";

/**
 * Represents data for a single reference line within a figure.
 */
export interface FigureReferenceLineDataDto {
  id: string;
  properties: FigureVarDataDto[];
}

/**
 * Type guard to check if an object is a FigureReferenceLineDataDto value.
 *
 * @param obj - The object to check.
 * @returns True when the value matches the reference line data shape.
 */
export const isFigureReferenceLineDataDto = (obj: unknown): obj is FigureReferenceLineDataDto => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureReferenceLineDataDto;
  if (typeof chkObj.id !== "string") {
    return false;
  }
  if (!Array.isArray(chkObj.properties)) {
    return false;
  }
  if (chkObj.properties.some((property) => !isFigureVarDataDto(property))) {
    return false;
  }
  return true;
};
